import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const RunPeriod = props => (
    <div className="form-input-container">
        <div>
        <b>Run Period<FaInfoCircle data-tip data-for='RunPeriod'/> </b>
        <ReactTooltip id='RunPeriod' place="right" type="light" effect="solid">
            Must be complete years nore more than 5.
        </ReactTooltip>
        </div>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>Start Year</InputLabel>
            <Input
                data-tip data-for="startYear"
                inputProps={{ min: "2010", max: "2030", step: "1" }}
                type="number"
                name="startYear"
                value={props.startYear}
                onChange={props.handleInputChange}
                placeholder='Example: 2015'/>
        </FormControl>
        <ReactTooltip id='startYear' place="bottom" type="light" effect="solid">
            Start year for this modeling project.
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>End Year</InputLabel>
            <Input
                data-tip data-for="endYear"
                inputProps={{ min: "2010", max: "2030", step: "1" }}
                type="number"
                name="endYear"
                value={props.endYear}
                onChange={props.handleInputChange}
                placeholder='Example: 2019'/>
        </FormControl>
        <ReactTooltip id='endYear' place="bottom" type="light" effect="solid">
            End year for this modeling project.
        </ReactTooltip>
    </div>
)
export default RunPeriod;
